import React from 'react';

function ArrowIconBody(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="8"
      height="15"
      viewBox="0 0 8 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1 13.4944L7 7.49445L1 1.49445"
        stroke={props.stroke || "#1E1E1E"} // Цвет можно переопределить через пропсы
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default ArrowIconBody;
